import Ely from '../images/ElyRichardT.jpg';


function ElyRichardT(){
    return (
        <>
        <img src={Ely} alt="Richard T Ely Portrait" className="faithImage" />
        </>
    );
};
export default ElyRichardT;